import React from 'react';

/**
 * Real photographic example of a headstone with MyLeaf logo + engraved QR.
 * Provided by the user as a brand-finished reference shot.
 */
export function HeadstoneEngravingExample({ className = '' }) {
  return (
    <img
      src="https://customer-assets.emergentagent.com/job_forever-here/artifacts/3azi1s6k_435ad495-81b1-4695-a7f4-3519b8f91036%20%281%29.png"
      alt="Example MyLeaf-engraved headstone with QR code"
      className={className}
      data-testid="headstone-engraving-example"
      loading="lazy"
    />
  );
}
